import React, { FC } from 'react';
import type { ILegoElemProps } from '../../Lego';
import { Input } from '@src/atoms/Input';
import { useLegoFormContext } from '../../_FormProvider/useLegoFormContext';
import { ILegoElemInput } from '../models';

export const LegoElemInput: FC<ILegoElemProps> = ({ elem, loading, errorMessage }) => {
  const { formHook } = useLegoFormContext();
  const inputElem = elem as ILegoElemInput;
  const value = formHook.watch(elem.id);

  return (
    <Input
      {...inputElem.input}
      {...formHook.register(elem.id)}
      id={elem.id}
      value={value}
      isHelpMessage
      errorMessage={errorMessage}
      disabled={inputElem.input.disabled ? true : loading}
    />
  );
};
